import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import classnames from 'classnames';
import sitemapStyles from '../components/Brand/Sitemap/Sitemap-tw-styles';
import { renderSitemapSection } from '../utils/sitemapHelper';
import { contentType, contentfulConstant } from '../constants/global';
import PGDataLayer from '../components/Generic/PGDataLayer/PGDataLayer';
import PageMetadata from '../components/Generic/PageMetadata';
import { defaultLangKey } from '../constants/languages';
import getInitialData from '../utils/helpers/initialDataHelper';
import { List } from '../components/Generic/List';
import Breadcrumb from '../components/Brand/Shared/Breadcrumb';
import Typography from '../components/Generic/Typography/Typography';
import DOMPurify from 'isomorphic-dompurify';

class SiteMap extends React.Component {
  static async getInitialProps({ query }) {
    const { locale } = query;
    let siteMapData = await getInitialData(
      contentfulConstant,
      contentType.siteMap,
      locale || defaultLangKey,
      query
    );
    return { siteMapData: siteMapData.data || {}, pageContext: query };
  }

  render() {
    const { siteMapData, pageContext, router } = this.props;
    const pageData = siteMapData.sitemapCollection.items[0];
    return (
      <React.Fragment>
        {pageData && pageData.pageMetadata && (
          <PGDataLayer
            locale={pageContext.locale}
            pageType={contentType.contentPage}
            path={router.asPath}
            title={pageData.pageMetadata && pageData.pageMetadata.pageTitle}
          />
        )}
        {pageData.pageMetadata && (
          <PageMetadata
            title={pageData.pageMetadata.pageTitle}
            metaTitle={pageData.pageMetadata.metaTitle}
            metaDescription={
              pageData.pageMetadata.metaDescription &&
              pageData.pageMetadata.metaDescription
            }
            orgTitle={pageData.pageMetadata.openGraphPageTitle}
            orgDescription={pageData.pageMetadata.openGraphDescription}
            metaKeywords={
              pageData.pageMetadata.metaKeywords &&
              pageData.pageMetadata.metaKeywords
            }
          />
        )}
        <div className={classnames(sitemapStyles.breadcrumbContainer)}>
          <Breadcrumb locale={pageContext.locale} currentUrl={router.asPath} />
        </div>
        <h1 className={sitemapStyles.hiddenClass}>SiteMap</h1>
        <div className={sitemapStyles.siteMapfixedWidthPages}>
          <div className={sitemapStyles.siteMapBG}>
            <div className={classnames(sitemapStyles.sitemapheading)}>
              {pageData.pageHeading && (
                <Typography
                  className={sitemapStyles.siteMapTypo}
                  component="span"
                  dangerouslySetInnerHTML={{
                    __html:DOMPurify.sanitize( pageData.pageHeading),
                  }}
                />
              )}
            </div>
            <div className={classnames(sitemapStyles.sitemapContainer)}>
              <div className={sitemapStyles.sitemapSection}>
                {pageData.sitemapSectionCollection &&
                  pageData.sitemapSectionCollection.items.map(sectionItem => {
                    return (
                      <List
                        key={sectionItem.id}
                        className={classnames(
                          sitemapStyles.sitemap &&
                            sitemapStyles.sitemap.sitemapLevelul,
                          sectionItem.styles
                        )}
                      >
                        {renderSitemapSection(sectionItem, 0, pageContext)}
                      </List>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SiteMap.propTypes = {
  siteMapData: PropTypes.objectOf(PropTypes.object).isRequired,
  pageContext: PropTypes.objectOf(PropTypes.object).isRequired,
  router: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default withRouter(SiteMap);
